import React from 'react';
import { Card, Group, Skeleton, Grid, Stack } from '@mantine/core';

/**
 * Structured placeholder shown while the Reviewing Test page loads its initial
 * data, so a reload presents the page layout (tabs, header controls, dropdowns,
 * table and chart sections) instead of a blank screen.
 */
export function ReviewingTestSkeleton() {
  return (
    <>
      {/* Variations / Variables tab */}
      <Skeleton height={36} width={130} radius="sm" mb={10} />

      {/* TEST card */}
      <Card shadow="sm" padding="sm" radius="md" withBorder>
        {/* Header: test title + right-side action controls */}
        <Group position="apart" mb="md">
          <Skeleton height={20} width={220} radius="sm" />
          <Group spacing={6}>
            <Skeleton height={36} width={36} radius="sm" />
            <Skeleton height={36} width={240} radius="sm" />
            <Skeleton height={36} width={36} radius="sm" />
            <Skeleton height={36} width={36} radius="sm" />
            <Skeleton height={36} width={36} radius="sm" />
          </Group>
        </Group>

        {/* "Conversions to:" label + radios + goal dropdown */}
        <Group spacing="md" mb="md">
          <Skeleton height={18} width={110} radius="sm" />
          <Skeleton height={18} width={70} radius="sm" />
          <Skeleton height={18} width={80} radius="sm" />
          <Skeleton height={18} width={90} radius="sm" />
          <Skeleton height={18} width={90} radius="sm" />
          <Skeleton height={36} width={250} radius="sm" />
        </Group>

        {/* Select Metrics dropdown */}
        <Skeleton height={40} width={330} radius="sm" mb="md" />

        {/* Predictive Winner Detection text */}
        <Skeleton height={14} width={200} radius="sm" mb={40} />

        {/* Data table area */}
        <Stack spacing="sm">
          <Skeleton height={40} radius="sm" />
          <Skeleton height={32} radius="sm" />
          <Skeleton height={32} radius="sm" />
          <Skeleton height={32} radius="sm" />
        </Stack>
      </Card>

      {/* CONVERSION TO PAGE/GOALS card */}
      <Card shadow="sm" padding="sm" radius="md" withBorder mt={15}>
        <Skeleton height={20} width={260} radius="sm" mb="md" />

        {/* Select Graph dropdown */}
        <Group spacing="md" mb="md">
          <Skeleton height={18} width={90} radius="sm" />
          <Skeleton height={36} width={260} radius="sm" />
        </Group>

        {/* Conversions / Conversion % radios */}
        <Group spacing="md" mb="md">
          <Skeleton height={18} width={110} radius="sm" />
          <Skeleton height={18} width={120} radius="sm" />
        </Group>

        {/* Chart area + Test Totals box */}
        <Grid>
          <Grid.Col span={9}>
            <Skeleton height={300} radius="sm" />
          </Grid.Col>
          <Grid.Col span={3}>
            <Stack spacing="sm" mt={20}>
              <Skeleton height={18} width="80%" radius="sm" />
              <Skeleton height={14} width="60%" radius="sm" />
              <Skeleton height={14} width="60%" radius="sm" />
              <Skeleton height={14} width="60%" radius="sm" />
            </Stack>
          </Grid.Col>
        </Grid>
      </Card>
    </>
  );
}
